import { normalizeCollectionResponse, projectTypeParams } from 'api';
import { client, computeHeaders } from 'queries';

export const projectTypesQuery = async ({ req, params }) => {
	const formattedParams = { ...projectTypeParams, context: ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/project-types`, headers, params: formattedParams });
	return normalizeCollectionResponse(response);
};
